import "./SideSheet.sass";

// Extensions
import VDialog from "../../../../node_modules/vuetify/lib/components/VDialog/VDialog";

/* @vue/component */
export default VDialog.extend({
  name: "v-side-sheet",

  props: {
    inset: Boolean,
    fullscreen: { default: true },
    maxWidth: [String, Number],
    transition: {
      type: String,
      default: "side-sheet-transition",
    },
    position: { type: String, default: "right" },
  },

  computed: {
    classes() {
      return {
        ...VDialog.options.computed.classes.call(this),
        "v-side-sheet": true,
        "v-side-sheet--inset": this.inset,
        "v-side-sheet--right": this.position === "right",
        "v-side-sheet--left": this.position === "left",
        "v-side-sheet--center": this.position === "center",
      };
    },
  },
});
